"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GA4ItemListName = void 0;
var GA4ItemListName;
(function (GA4ItemListName) {
    GA4ItemListName["Recommendation"] = "Recommendation";
    GA4ItemListName["SearchBestseller"] = "Search Bestseller";
    GA4ItemListName["SearchLastSeen"] = "Search Last Seen";
    GA4ItemListName["SearchSuggestSearchProduct"] = "Search Suggest Search Product";
    GA4ItemListName["Bestseller"] = "Bestseller";
    GA4ItemListName["LastSeen"] = "Last seen";
    GA4ItemListName["Category"] = "Category";
    GA4ItemListName["Wishlist"] = "Wishlist";
    GA4ItemListName["Cart"] = "Cart";
    GA4ItemListName["Highlight"] = "highlight";
    GA4ItemListName["ClusterPDP"] = "Cluster PDP";
    GA4ItemListName["ClusterPDPPopUp"] = "Cluster PDP PopUp";
})(GA4ItemListName || (exports.GA4ItemListName = GA4ItemListName = {}));
//# sourceMappingURL=GA4ItemListName.js.map